import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';

import { getDistributionStationList } from '@/api/modules/system-management/distributionStation-management';

export const getDistributionStationUserList = data => {
    return axios.request({
        url: 'api/accountManagement/distributionStationUserManagement/getDistributionStationUserList',
        data: data,
        method: 'post'
    });
};

export const getDistributionStationUserDetail = userDistributionStationLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/distributionStationUserManagement/getDistributionStationUserDetail',
        data: { userDistributionStationLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserDistributionStationEdit = () => {
    const distributionStation = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getDistributionStationList(distributionStation)
    ]).then(axiosRequest.spread(function (distributionStation) {
        if (distributionStation.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    distributionStation: distributionStation.data
                }
            };
        }
        else {
            return {
                code: distributionStation.code || -1,
                message: distributionStation.message || '获取转运站列表失败',
                data: {
                    distributionStation: { records: [] }
                }
            };
        }
    })).catch(error => {
        console.error('获取转运站列表失败:', error);
        return {
            code: -1,
            message: '获取转运站列表失败',
            data: {
                distributionStation: { records: [] }
            }
        };
    });
};

export const distributionStationUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/distributionStationUserManagement/distributionStationUserSave',
        data: data,
        method: 'post'
    });
};
